import { Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";

type FindClosestProfileRow = {
  row: Row;
  rowsByKey: Record<string, Row>;
};

export const findClosestProfileRow = ({ row, rowsByKey }: FindClosestProfileRow): Row | undefined => {
  const chain = [row.key, ...[...row.parents].reverse()];
  return chain.map((key) => rowsByKey[key]).find((row): row is Row => !!row && row.type === RowType.Profile);
};
